import { SHOW, HIDE } from './busy-indicator-actions';

const defaultState = {
    callCounter: 0,
    message: 'Loading...'
};

export default function (state = defaultState, action) {
    if (!action) {
        return state;
    }

    const { type } = action;
    switch (type) {
        case SHOW:
            return {
                ...state,
                callCounter: state.callCounter + 1
            };
        case HIDE:
            return {
                ...state,
                callCounter: state.callCounter > 0 ? state.callCounter - 1 : 0
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/busy-indicator/busy-indicator-reducer.js